import { AuditLogDTO } from 'features/history/types/auditLogDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const AUDIT_LOG_FRAGMENT: TypedDocumentNode<AuditLogDTO> = gql`
  fragment AuditLogFragment on AuditLog {
    logEntry
  }
`
